// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
	let id = wixLocation.query.id;
	console.log(id);
	if (id) {
		wixWindow.openLightbox('PRODUCT', id);
	}
});